export const validateMenuContainer = ({ mouseX, mouseY }) => {
    const offset = 10;
    const yBottom = 73;
    //Avoid SmartTag menu buttons
    const buttonContainer = document.querySelector('.btn-audio-cc')?.parentElement;
    if (!buttonContainer) {
        return mouseY < yBottom;
    }
    const boundaries = buttonContainer.getBoundingClientRect();
    let positionLeft = boundaries.left - offset;
    positionLeft = positionLeft > 0 ? positionLeft : 0;
    return mouseX < positionLeft && mouseY < yBottom;
};
